/**
 * Perfil de memoria para MPR: full | light | blocked
 */
import { getResourceHints } from './mobileDownloadProfile'

const MiB = 1024 * 1024

/** Bytes estimados del volumen Int16 crudo (sin interpolar). */
export function estimateMprBytes(cols, rows, nSlices) {
  const c = Math.max(1, Number(cols) || 1)
  const r = Math.max(1, Number(rows) || 1)
  const n = Math.max(1, Number(nSlices) || 1)
  return c * r * n * 2
}

/**
 * Presupuesto aproximado de heap usable para volumen MPR.
 * deviceMemory está en GiB y es grueso; en iOS suele ser null.
 */
function budgetBytes(hints) {
  const h = hints || getResourceHints()
  if (h.deviceMemory != null) {
    // ~35% de la RAM reportada, con techos por clase
    const raw = h.deviceMemory * 1024 * MiB * 0.35
    if (h.phone) return Math.min(raw, 220 * MiB)
    if (h.constrained) return Math.min(raw, 320 * MiB)
    return Math.min(raw, 512 * MiB)
  }
  if (h.phone) return 180 * MiB
  if (h.constrained) return 260 * MiB
  return 400 * MiB
}

/**
 * @param {{ cols: number, rows: number, nSlices: number, hints?: object }} args
 * @returns {'full'|'light'|'blocked'}
 */
export function resolveMprProfile({ cols, rows, nSlices, hints }) {
  const h = hints || getResourceHints()
  const estimated = estimateMprBytes(cols, rows, nSlices)
  const budget = budgetBytes(h)

  if (estimated > budget) return 'blocked'

  // Phone / constrained: full solo si cabe holgado
  if (h.phone || h.constrained) {
    if (estimated > budget * 0.55) return 'light'
    // high-end phone / tablet con serie chica
    if (h.deviceMemory != null && h.deviceMemory >= 6 && estimated < budget * 0.4) {
      return 'full'
    }
    if (!h.phone && h.constrained && estimated < budget * 0.45) return 'full'
    return 'light'
  }

  return 'full'
}

export function mprProfileAllowsOrthogonal(profile) {
  // light: planos on-demand (sin volumen isótropo); suficiente para 3 viewports
  return profile === 'full' || profile === 'light'
}

export function mprProfileLabel(profile) {
  if (profile === 'blocked') return 'Memoria insuficiente para MPR en este dispositivo.'
  if (profile === 'light') return 'MPR ligero (planos on-demand).'
  return 'MPR completo.'
}
